import { dark } from "@clerk/themes";

/** Keep this value synchronized with --color-brand-primary in index.css. */
const BRAND_PRIMARY = "#9aca48";
const BRAND_PRIMARY_FOREGROUND = "#0a0a0a";
const PRODUCT_BACKGROUND_LIGHT = "#ffffff";
const PRODUCT_BACKGROUND_DARK = "#0a0a0a";
const PRODUCT_INPUT_BACKGROUND_LIGHT = "#f5f5f5";
const PRODUCT_INPUT_BACKGROUND_DARK = "#262626";
const PRODUCT_FOREGROUND_LIGHT = "#0a0a0a";
const PRODUCT_FOREGROUND_DARK = "#fafafa";

const clerkCardElements = {
  rootBox: "mx-auto w-full",
  card: "shadow-lg border border-border/60",
  headerTitle: "text-foreground",
  headerSubtitle: "text-muted-foreground",
  socialButtonsBlockButton: "border-border",
  buttonArrowIcon: "hidden",
};

export function getClerkAppearance(isDark: boolean) {
  if (isDark) {
    return {
      baseTheme: dark,
      variables: {
        colorPrimary: BRAND_PRIMARY,
        colorPrimaryForeground: BRAND_PRIMARY_FOREGROUND,
        colorBackground: PRODUCT_BACKGROUND_DARK,
        colorInputBackground: PRODUCT_INPUT_BACKGROUND_DARK,
        colorInputText: PRODUCT_FOREGROUND_DARK,
      },
      elements: clerkCardElements,
    };
  }

  return {
    variables: {
      colorPrimary: BRAND_PRIMARY,
      colorPrimaryForeground: BRAND_PRIMARY_FOREGROUND,
      colorBackground: PRODUCT_BACKGROUND_LIGHT,
      colorInputBackground: PRODUCT_INPUT_BACKGROUND_LIGHT,
      colorInputText: PRODUCT_FOREGROUND_LIGHT,
    },
    elements: clerkCardElements,
  };
}
